import React, { useState } from "react"
import * as s from "./phone.module.scss"
import amFlag from "./am.png"
import azFlag from "./az.png"
import byFlag from "./by.png"
import kgFlag from "./kg.png"
import kzFlag from "./kz.png"
import mdFlag from "./md.svg"
import ruFlag from "./ru.svg"
import geFlag from "./ge.png"
import tjFlag from "./tj.png"
import tmFlag from "./tm.png"
import uaFlag from "./ua.png"
import uzFlag from "./uz.png"

const PhoneInputValidate = ({
  className,
  onChange,
  onValidationChange,
  onTouchedChange,
}: {
  className: string
  onChange: (value: string) => void
  onValidationChange: (isValid: boolean) => void
  onTouchedChange: () => void
}) => {
  const [selectedCountry, setSelectedCountry] = useState(countries[0])
  const [phoneNumber, setPhoneNumber] = useState("")
  const [showDropdown, setShowDropdown] = useState(false)
  const [error, setError] = useState(false)
  const [isTouched, setIsTouched] = useState(false)

  const validateInput = (value: string) => {
    const { code } = selectedCountry
    const isValidLength = value.length >= phoneLengths[code].min && value.length <= phoneLengths[code].max
    const noRepeatingChars = !/(.)\1{5,}/.test(value)
    const noLettersOrSpecialChars = /^[0-9]+$/.test(value)
    return isValidLength && noRepeatingChars && noLettersOrSpecialChars
  }

  const handleSelectCountry = (country) => {
    setSelectedCountry(country)
    setShowDropdown(false)
    setPhoneNumber("")
    setError(false)
    setIsTouched(false)
    onChange("")
    onValidationChange(false)
  }

  const handleInputChange = (e) => {
    const { value } = e.target
    const dialCode = selectedCountry.dialCode

    if (!isTouched) {
      setIsTouched(true)
      onTouchedChange()
    }

    setPhoneNumber(value)
    const isValid = validateInput(value)
    setError(!isValid)
    onChange(`${dialCode}${value}`)
    onValidationChange(isValid)
  }

  return (
    <div className={`${s.phoneInputValidate} ${className}`}>
      <div className={s.inputContainer}>
        <button type="button" className={`${s.flagButton} ${showDropdown ? s.flagButton_active : ""}`} onClick={() => setShowDropdown(!showDropdown)}>
          <svg width="18" height="10" viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L8.29289 8.29289C8.68342 8.68342 9.31658 8.68342 9.70711 8.29289L17 1" stroke="#717171" strokeWidth="2" strokeLinecap="round" />
          </svg>
          {selectedCountry.dialCode}
        </button>

        <label htmlFor="phoneInput" className={`${s.phoneLabel} ${phoneNumber ? s.hidden : ""}`}>
          987 654 32 10<span className={s.required}>*</span>
        </label>

        <input
          type="number"
          id="phoneInput"
          className={`${s.phoneInput} ${isTouched ? (error ? s.invalid : s.success) : ""}`}
          value={phoneNumber}
          onChange={handleInputChange}
        />
      </div>

      {error && isTouched && <span className={s.error}>Введите корректный номер телефона</span>}

      {showDropdown && (
        <div>
          <ul className={s.dropdown}>
            {countries.map((country) => (
              <li key={country.code} className={s.dropdownItem} onClick={() => handleSelectCountry(country)}>
                <img src={country.flag} alt={country.name} className={s.dropdownFlag} />
                <span className={s.dropdownCode}>{country.dialCode}</span>
                <span>{country.name}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}

export default PhoneInputValidate

// Структура данных для стран
const countries = [
  { code: "ru", name: "Россия", dialCode: "+7", flag: ruFlag },
  { code: "by", name: "Беларусь", dialCode: "+375", flag: byFlag },
  { code: "kz", name: "Казахстан", dialCode: "+7", flag: kzFlag },
  { code: "ua", name: "Украина", dialCode: "+380", flag: uaFlag },
  { code: "am", name: "Армения", dialCode: "+374", flag: amFlag },
  { code: "az", name: "Азербайджан", dialCode: "+994", flag: azFlag },
  { code: "ge", name: "Грузия", dialCode: "+995", flag: geFlag },
  { code: "kg", name: "Кыргызстан", dialCode: "+996", flag: kgFlag },
  { code: "md", name: "Молдова", dialCode: "+373", flag: mdFlag },
  { code: "tj", name: "Таджикистан", dialCode: "+992", flag: tjFlag },
  { code: "tm", name: "Туркменистан", dialCode: "+993", flag: tmFlag },
  { code: "uz", name: "Узбекистан", dialCode: "+998", flag: uzFlag },
]

// Длина номера для каждой страны
const phoneLengths = {
  ru: { min: 10, max: 10 },
  ua: { min: 9, max: 9 },
  by: { min: 9, max: 9 },
  kz: { min: 10, max: 10 },
  am: { min: 6, max: 8 },
  az: { min: 9, max: 9 },
  ge: { min: 6, max: 9 },
  kg: { min: 9, max: 9 },
  md: { min: 6, max: 8 },
  tj: { min: 9, max: 9 },
  tm: { min: 6, max: 8 },
  uz: { min: 9, max: 9 },
}
